import walletFinancialPositionsMessages from '../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../column';
import { TraditionalInsuranceProduct } from '../traditional-insurance-macro-category';

export const traditionalInsuranceColumns: Column<TraditionalInsuranceProduct>[] =
  [
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
      key: 'productName',
      type: 'string',
    },
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderContract,
      key: 'newContractCode',
      type: 'string',
    },
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderDate,
      key: 'date',
      type: 'date',
    },
    {
      headerLabel:
        walletFinancialPositionsMessages.tableHeaderTotalPremiumsPaid,
      key: 'totalPremiumsPaid',
      type: 'amount',
    },
  ];
